import { Editor } from "@tinymce/tinymce-react";
import { ColumnType } from "./DataTable.types";
import { CellEditorProps } from "./CellEditor.types";
import { TinyMCEConfigs } from '../TinyMCE/tinyMCEConfig';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const CellEditor = <T,>({
  type,
  value,
  onChange,
  inputProps,
  sx,
  ...rest
}: CellEditorProps<T> & { [key: string]: any }) => {
  switch (type) {
    case ColumnType.select:
      return (
        <select value={value ?? ''} onChange={(e) => onChange(e.target.value)} {...rest}>
          {rest.options?.map((opt: any) => (
            <option key={String(opt.value)} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    case ColumnType.text:
      return (
        <input
          type="text"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          {...rest}
        />
      );
    case ColumnType.number:
      return (
        <input
          type="number"
          value={value ?? ''}
          onChange={(e) => onChange(Number(e.target.value))}
          {...rest}
        />
      );
    case ColumnType.date:
      return (
        <input
          type="date"
          value={typeof value === 'string' ? value.slice(0, 10) : (value ?? '')}
          onChange={(e) => onChange(e.target.value)}
          {...rest}
        />
      );
    case ColumnType.time:
      return (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="pl" // for Polish locale
        >
          <TimePicker
            ampm={false}
            value={value ? dayjs(value, 'HH:mm') : null}
            onChange={(newValue) => {
              onChange(newValue ? newValue.format('HH:mm') : '');
            }}
            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
          />
        </LocalizationProvider>
      );
    case ColumnType.checkbox:
      return (
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} />
      );
    case ColumnType.wysiwyg:
      // użyj swojego TinyMCE/Editor
      return (
        <div style={{ minWidth: 250, maxWidth: 500 }}>
          <Editor
            licenseKey="gpl"
            tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
            apiKey="hl8vxlvwl4bzp1mcvxs7a4199tjukwpgx6tzzzztpzwth5ir"
            value={value ?? ''}
            init={TinyMCEConfigs.cell()}
            onEditorChange={(content) => onChange(content)}
          />
        </div>
      );
    // Dodaj kolejne typy wg potrzeb
    default:
      return <span>{value ?? ''}</span>;
  }
};
export default CellEditor;